/* eslint-disable no-undef */
import ObjectStorage from "../modules/ObjectStorage";
import get from "lodash/get";
import Navigation from "./NavigationService";
import { StorageConstants } from "../constants/AppConstants";

//------------------------------------------------------------------------------------------

const AuthService = {
  _getAccessToken() {
    return get(ObjectStorage.getItem(StorageConstants.ACCESS_TOKEN), "token");
  },
  _getRefreshToken() {
    return get(ObjectStorage.getItem("refreshToken"), "token");
  },
  logout() {
    ObjectStorage.removeItem(StorageConstants.ACCESS_TOKEN);
    ObjectStorage.removeItem(StorageConstants.REFRESH_TOKEN);
    ObjectStorage.removeItem(StorageConstants.MERCHANT_DETAILS);
    Navigation.navigateToLogin();
  },
  _getMerchantDetails() {
    return ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS, "data");
  },
  getMerchantDetailsFromToken() {
    return (
      JSON.parse(
        window.atob(AuthService._getAccessToken()?.split?.(".")?.[1])
      ) || ""
    );
  },
  goto404() {
    window.location.href = "*";
  },
  _getMerchantId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.merchantId"
    );
  },
  _getLocalTerminalName() {
    return get(
      ObjectStorage.getItem(StorageConstants.ACCOUNT_BACKUP_DETAILS),
      "data.terminalName"
    );
  },
  getDeviceId() {
    return get(ObjectStorage.getItem(StorageConstants.DEVICE_UNIQUE_ID), "id");
  },

  getRemoteURL() {
    const { data: remoteUrl } = ObjectStorage.getItem(
      StorageConstants.REMOTE_URL
    );

    return remoteUrl
      ? `https://${remoteUrl}.positeasy.in`
      : "https://api.positeasy.in";
  },
  getShopName() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.storeName",
      ""
    );
  },
  getAddress() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.address",
      ""
    );
  },
  getStoreId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.storeId"
    );
  },
  getStoreReference() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.storeReference"
    );
  },
  setStoreReference(storeReference) {
    ObjectStorage.setItem(StorageConstants.MERCHANT_DETAILS, {
      data: {
        ...get(
          ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
          "data"
        ),
        storeReference: storeReference,
      },
    });
  },
  getTerminalId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.terminalId"
    );
  },
};

export default AuthService;
